module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-04.e4010fd3.jpg";